'use client';

import { ToggleGroup, ToggleGroupItem } from '@eliadmin/core/src/components/ui/toggle-group';
import { useCategorySort } from '@eliadmin/core/src/hooks/category/use-category-sort';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';

type CategorySortProps = {
  className?: string;
};

export function CategorySortToggle(props: CategorySortProps) {
  const { t } = useTranslations();
  const { selectedValue, onSortChange, VALUES } = useCategorySort();

  return (
    <ToggleGroup
      type="single"
      value={selectedValue}
      onValueChange={onSortChange}
      className={cn(
        'hide-scroll-bar flex w-full items-start justify-start gap-2 overflow-x-auto sm:w-auto',
        'ea-category-sort',
        props.className,
      )}
    >
      {VALUES.map(o => (
        <ToggleGroupItem
          key={o.value}
          value={String(o.value)}
          className={cn(
            'flex h-[33px] items-center justify-center whitespace-nowrap rounded-none border px-6 font-oswald text-sm font-normal uppercase data-[state=on]:pointer-events-none data-[state=off]:border-border data-[state=on]:border-black data-[state=on]:bg-black data-[state=off]:text-black data-[state=on]:text-white data-[state=off]:hover:bg-neutral-100 sm:h-10 sm:text-base lg:h-[52px] lg:text-lg',
            'ea-category-sort__select-item',
          )}
        >
          {t(o.label)}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}

export default CategorySortToggle;
